// SPDX-License-Identifier: FSL-1.1-Apache-2.0
import type { ConsentSettings } from "@geenius/analytics";

export interface ConsentPreferenceState {
  analytics: boolean;
  functional: boolean;
  marketing: boolean;
  personalization: boolean;
}

export type ConsentPreferenceKey = keyof ConsentPreferenceState;

export const consentCategories: Array<{
  key: ConsentPreferenceKey;
  label: string;
  testID: string;
}> = [
  { key: "functional", label: "Functional", testID: "functional" },
  { key: "analytics", label: "Analytics", testID: "analytics" },
  { key: "marketing", label: "Marketing", testID: "marketing" },
  {
    key: "personalization",
    label: "Personalization",
    testID: "personalization",
  },
];

export function createInitialConsentPreferences(
  initialSettings?: Partial<ConsentSettings>,
): ConsentPreferenceState {
  return {
    analytics: initialSettings?.analytics ?? false,
    functional: initialSettings?.functional ?? true,
    marketing: initialSettings?.marketing ?? false,
    personalization: initialSettings?.personalization ?? false,
  };
}

export function updateConsentPreference(
  preferences: ConsentPreferenceState,
  key: ConsentPreferenceKey,
  value: boolean,
): ConsentPreferenceState {
  return { ...preferences, [key]: value };
}

export function createConsentSettings(
  preferences: ConsentPreferenceState,
  now: () => number = Date.now,
): ConsentSettings {
  return {
    essential: true,
    analytics: preferences.analytics,
    functional: preferences.functional,
    marketing: preferences.marketing,
    personalization: preferences.personalization,
    timestamp: now(),
  };
}

export function createAcceptAllConsent(
  now: () => number = Date.now,
): ConsentSettings {
  return createConsentSettings(
    {
      analytics: true,
      functional: true,
      marketing: true,
      personalization: true,
    },
    now,
  );
}

export function createRejectOptionalConsent(
  now: () => number = Date.now,
): ConsentSettings {
  return createConsentSettings(
    {
      analytics: false,
      functional: false,
      marketing: false,
      personalization: false,
    },
    now,
  );
}
